import { CALENDAR_VIEW_TYPE } from "../types/account/enum";

export const CALENDAR_VIEW_LABEL = {
  [CALENDAR_VIEW_TYPE.DAY1]: "1 day",
  [CALENDAR_VIEW_TYPE.DAY3]: "3 days",
  [CALENDAR_VIEW_TYPE.WEEK]: "Weekly",
  [CALENDAR_VIEW_TYPE.MONTH]: "Monthly",
} as const;
